import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipDialogModule } from './tip-dialog/tip-dialog.module';
import { TipComponent } from './tip.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ TipComponent
  ],
  imports: [
    CommonModule,
    TipDialogModule,
    MatIconModule,
    TranslateModule
  ],
  exports: [
    TipComponent
  ]
})
export class TipModule { }